// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3c672bbbfabfbea6d27c6408dc749a429d70cd11.chunk.js";
};